module.exports = __webpack_public_path__ + "lato-black-webfont.f1b13d6df74c934e6560.woff2";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-black-webfont.woff2
// module id = ../../../../../resources/layout/fonts/lato-black-webfont.woff2
// module chunks = styles